import React from 'react';

function Desktop() {
    return (
        <div
            style={{
                position: 'fixed',
                top: '71px',
                left: 0,
                right: 0,
                bottom: 0,
                overflow: 'hidden',
            }}
        >
            <iframe
                src=" "
                title="Desktop"
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                }}
            />
        </div>
    );
}

export default Desktop;
